const React = require("react");
import LiquorItem from "./liquor-item";
import * as actions from "../actions/";
import { connect } from "react-redux";
import axios from "axios";
const qs = require("querystring");
const _ = require("lodash");
const NotificationSystem = require("react-notification-system");
export class ProductItem extends React.Component {
    constructor() {
        super(...arguments);
        this._notificationSystem = null;
        this.editShopping = () => {
            if (this.props.shoppingList &&
                this.props.IncrementList &&
                this.props.DecrementList &&
                this.props.ToggleLogin) {
                if (this.props.authenticated) {
                    if ([...this.props.shoppingList, this.props.id].length > 20 &&
                        this.props.shoppingList.indexOf(this.props.id) === -1) {
                        this._notificationSystem.addNotification({
                            message: "Exceed Shopping Cart Limit (Max 20 Items)",
                            level: "error"
                        });
                    }
                    else {
                        let ShoppingList = this.props.shoppingList.indexOf(this.props.id) === -1
                            ? [...this.props.shoppingList, this.props.id].toString()
                            : this.props.shoppingList
                                .filter((x) => {
                                return x !== this.props.id;
                            })
                                .toString();
                        axios
                            .post("/Manage/SetShoppingList", qs.stringify({
                            ShoppingList
                        }))
                            .then(() => {
                            this.props.shoppingList.indexOf(this.props.id) === -1
                                ? this.props.IncrementList(this.props.id)
                                : this.props.DecrementList(this.props.id);
                        });
                    }
                }
                else {
                    this.props.ToggleLogin();
                }
            }
        };
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    render() {
        let button = !this.props.showWhereToBuy ? (React.createElement("button", { className: "btn-primary btn-primary__filled", onClick: this.editShopping }, this.props.shoppingList &&
            this.props.shoppingList.indexOf(this.props.id) === -1
            ? "ADD TO LIST"
            : "REMOVE FROM LIST")) : (React.createElement("a", { href: `/Products/Stores/${this.props.id}` },
            React.createElement("button", { className: "btn-primary btn-primary__filled" }, "WHERE TO BUY")));
        let removeIcon = (!this.props.hideShoppingControls && this.props.showWhereToBuy && (this.props.shoppingList.indexOf(this.props.id) >= 0)) ? (React.createElement("i", { className: "fa fa-times-circle remove-icon", onClick: this.editShopping })) : null;
        return (React.createElement("div", { className: "product-item" },
            removeIcon,
            React.createElement(NotificationSystem, { ref: "notificationSystem" }),
            React.createElement(LiquorItem, Object.assign({}, this.props)),
            button));
    }
}
export const mapStateToProps = ({ shoppingList, authenticated, signInModal }, ownProps) => {
    return {
        shoppingList,
        authenticated
    };
};
export function mapDispatchToProps(dispatch) {
    return {
        DecrementList: (liquor) => dispatch(actions.DecrementList(liquor)),
        IncrementList: (liquor) => dispatch(actions.IncrementList(liquor)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductItem);
//# sourceMappingURL=product-item.js.map